const Button = ({
  children,
  buttonValue = children ? "" : "button",
  type = "submit",
  onClickFunction,
  className,
  disabled,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      disabled={disabled}
      onClick={onClickFunction}
      className={`lg:text-center rounded-full sm:text-xs hover:scale-90 place-content-center
       items-center transition duration-500 group relative shadow-md flex justify-center gap-1 py-1 bg-primary  
       border border-transparent text-white  h-6 w-20 focus:outline-none focus:ring-2 focus:ring-offset-2 
       focus:ring-primary focus:ring-opacity-70 ${className}`}
    >
      {buttonValue}
      {children}
    </button>
  );
};

export default Button;
